export default [
  {
    name: 'dormEmployeeFeeList',
    path: '/dormManagement/dormEmployeeFeeList',
    component: () => import('@/views/dormManagement/dormEmployeeFeeList/index.vue'),
    meta: {
      title: '住宿人员水电费明细'
    }
  },
  {
    name: 'dormRoomFeeList',
    path: '/dormManagement/dormRoomFeeList',
    component: () => import('@/views/dormManagement/dormRoomFeeList/index.vue'),
    meta: {
      title: '住宿房间水电费明细'
    }
  },
  {
    name: 'employeeRoomCountList',
    path: '/dormManagement/employeeRoomCountList',
    component: () => import('@/views/dormManagement/employeeRoomCountList/index.vue'),
    meta: {
      title: '人员宿舍统计报表'
    }
  },
  {
    name: 'dormPropertyManagement',
    path: '/dormManagement/dormPropertyManagement',
    component: () => import('@/views/dormManagement/dormPropertyManagement/index.vue'),
    meta: {
      title: '宿舍楼盘管理'
    }
  },
  {
    name: 'dormRoomManagement',
    path: '/dormManagement/dormRoomManagement',
    component: () => import('@/views/dormManagement/dormRoomManagement/index.vue'),
    meta: {
      title: '宿舍房间管理'
    }
  },
  {
    name: 'dormCheckInManagement',
    path: '/dormManagement/dormCheckInManagement',
    component: () => import('@/views/dormManagement/dormCheckInManagement/index.vue'),
    meta: {
      title: '入住手续管理'
    }
  },
  {
    name: 'dormChangeRoomManagement',
    path: '/dormManagement/dormChangeRoomManagement',
    component: () => import('@/views/dormManagement/dormChangeRoomManagement/index.vue'),
    meta: {
      title: '换房手续管理'
    }
  },
  {
    name: 'dormCheckOutManagement',
    path: '/dormManagement/dormCheckOutManagement',
    component: () => import('@/views/dormManagement/dormCheckOutManagement/index.vue'),
    meta: {
      title: '退房手续管理'
    }
  },
  {
    name: 'dormRoomResource',
    path: '/dormManagement/dormRoomResource',
    component: () => import('@/views/dormManagement/dormRoomResource/index.vue'),
    meta: {
      title: '房间资源'
    }
  },
  {
    name: 'dormFeeManagement',
    path: '/dormManagement/dormFeeManagement',
    component: () => import('@/views/dormManagement/dormFeeManagement/index.vue'),
    meta: {
      title: '水电费管理'
    }
  },
  {
    name: 'dormElectricFee',
    path: '/dormManagement/dormElectricFee',
    component: () => import('@/views/dormManagement/dormFeeManagement/dormElectricFee.vue'),
    meta: {
      title: '月度电费维护',
      parentAuth: '/dormManagement/dormFeeManagement'
    },
    props: () => ({})
  },
  {
    name: 'dormWaterFee',
    path: '/dormManagement/dormWaterFee',
    component: () => import('@/views/dormManagement/dormFeeManagement/dormWaterFee.vue'),
    meta: {
      title: '月度水费维护',
      parentAuth: '/dormManagement/dormFeeManagement'
    },
    props: () => ({ })
  },
  {
    name: 'dormOtherFee',
    path: '/dormManagement/dormOtherFee',
    component: () => import('@/views/dormManagement/dormFeeManagement/dormOtherFee.vue'),
    meta: {
      title: '月度杂费维护',
      parentAuth: '/dormManagement/dormFeeManagement'
    },
    props: () => ({ })
  },
]
